module.exports = "https://health.dajiuxing.com.cn/img/assets/personalInformation/rescueProcessing.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FpersonalInformation%2FrescueProcessing.png
// module id = rEif
// module chunks = 93